import React from 'react';

import fetch from '../fetch';

import moment from 'moment';

import utils from '../../utils';

import {Modal, message, Button} from 'antd';

const DataGrid = {
    selections: [],
    resultStateSelections: [],
    refresh: function() {

    }
}

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号', width: 75},
    {key:'orgName', label: '部门', width: 150},
    {key:'targetName', label: '测评项目', width: 130},
    {key:'employeeName', label: '教师', width: 70},
    {key:'courseName', label: '课程名称', width: 150},
    {key:'resultScore', label: '分数', width: 70},
    {key:'resultGrade', label: '等级', width: 70},
    {key:'courseHours', label: '课时', width: 70},
    {key:'evalTime', label: '预提交日期', width: 120, render: (value)=> value ? moment(new Date(value)).format('YYYY/MM/DD') :""},
    {key:'submitTime', label: '正式提交日期', width: 120, render: (value)=> value ? moment(new Date(value)).format('YYYY/MM/DD') : ""},
    {key:'status', label: '提交状态', width: 90, render:(d) => (+d === 1 ? '已正式提交' : '预提交')},
    {key:'termName', label: '所属学期/学年', width: 130}
]);



/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] !== '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('eval/result3/list?' + params.join('&'), keywords)
    .then(response => {
        return {
            data: response.payload.data,
            meta: response.payload.meta
        };
    })
    .then(response => (Object.assign({
        result: (response.data.dataList || []),
        selects: (response.data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        meta: response.meta,
        checked: false,
        total: response.data.total,
        pageIndex: response.data.pageNum,
        pageSize: response.data.pageSize,
        notify: (response.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method batchSubmit
 * @return {promise}
 */
const batchSubmit = (callback) => {
    return fetch.post('eval/result/batch/submit', DataGrid.selections)
    .then(response => {
        if(response.code === 200) {
            message.success("提交成功！");
            callback();
        }
    });
}

/**
 * @method batchBack
 * @return {promise}
 */
const batchBack = (callback) => {
    return fetch.post('eval/result/batch/back', DataGrid.selections)
    .then(response => {
        if(response.code === 200) {
            message.success("回退成功！");
        }

        callback();
        return response;
    });
}

/**
 * @method remove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const remove = (ids) => {
    return fetch.post('eval/result3/delete', ids)
    .then(response => {
        return response;
    }).catch(error => {
        return error;
    });
}

/**
 * @method batchRemove
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const batchRemove = (callback) => {
    if(DataGrid.selections.length === 0) {
        Modal.warn({
            title: '请先选择一项或多项！',
            content: '只有勾选一项或多项后才能删除！',
        });
    } else {
        Modal.confirm({
            title: '确定删除该记录？',
            content: '删除后将无法恢复！',
            onOk() {
                remove(DataGrid.selections).then(response => {
                    if(response.code === 200) {
                        message.success(response.message);
                        callback();
                    }
                });
            },
            onCancel() {},
            okText:"确认",
            cancelText:"取消"
        });
    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onResultStateSelect = (ids) => {
    DataGrid.resultStateSelections = ids;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const getResultStateSelect = () => {
    return DataGrid.resultStateSelections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    window.location.hash = 'eval/result'+ url;
};

const getSelection =() => {
    return DataGrid.selections;
}

/**
 * @method batchUpdate
 * @return {void}
 */
const batchUpdate = () => {
    if(DataGrid.selections.length === 0 || DataGrid.selections.length > 1) {
        Modal.error({
            title: '请先选择一项！',
            content: '只有勾选一项后才能更新！',
            okText:"确认",
        });
    } else {
        redirect('/update/'+ DataGrid.selections[0]);
    }
}

const queryDetailById = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.get('eval/result3/detail/' + keywords.id)
    .then(response => {
        return response.payload;
    }).then(responseData => {
        const data = responseData.data
        const domain = {
            orgId: data.orgId,
            orgName: data.orgName,
            employeeId: data.employeeId,
            employeeName: data.employeeName,
            courseId: data.courseId,
            courseName: data.courseName,
            evalId: data.targetId,
            resultComment: data.resultComment || '',
            resultScore: data.resultScore,
            commentDesc: data.commentDesc
        }
        return {
            data: data.evalTargetList.map(evals => {
                return {
                    id: evals.id,
                    pid: evals.pid,
                    label: evals.evalName,
                    children: evals.evalSubItem.map(sub => {
                        return {
                            id: sub.id,
                            pid: sub.itemId,
                            label: sub.subName,
                            choices: sub.choices,
                            selectLabel: sub.selectLabel,
                            selectScore: sub.selectScore
                        }
                    })
                }
            }),
            domain: domain,
        };
    })
    .then(response => {
        var scores = {};
        var parents = {};
        var values = {};

        var keys = [];

        response.data.forEach(row => {
            parents["P" + row.id] = "P" + row.pid;
            values["P" + row.id] = row.label;

            row.children.forEach(child => {
                var childId = "C" + child.id;
                parents[childId] = "P" + child.pid;
                scores[childId] = child;
                keys.push(childId);
            });
        });

        return {
            scores,
            parents,
            values,
            keys,
            domain: response.domain,
        };
    }).then(response => {
        var data = response.keys.map(key => {
            return getParents(key, response.parents, []);
        });

        var columnMaxValue = Math.max.apply(Math, data.map(d => d.length));

        var rowsCount = response.keys.length;
        return {
            scores: response.scores,
            values: response.values,
            columnMaxValue,
            rowsCount,
            data: data.map(function (d) {
                var size = columnMaxValue - d.length;
                var index = d.length - 2;
                var value = d[index];
                for (var i = 0; i < size; i++) {
                    d.splice(index + i, 0, value);
                }
                return d;
            }),
            domain: response.domain,
        };
    }).then(response => {
        var columnMaxValue = response.columnMaxValue;
        var rowsCount = response.rowsCount;
        
        var grid = [];

        for (var i = 0; i < columnMaxValue; i++) {
            var lastValue = '';
            var lastIndex = 0;

            grid.push([]);

            for (var k = 0; k < rowsCount; k++) {
                var currentValue = response.data[k][i];

                if (lastValue !== currentValue) {
                    lastIndex = k;
                    lastValue = currentValue;

                    grid[i][k] = {
                        rowspan: 1,
                        value: currentValue
                    };
                } else {
                    grid[i][lastIndex].rowspan = grid[i][lastIndex].rowspan + 1;

                    grid[i][k] = {
                        rowspan: 0,
                        value: currentValue
                    };
                }
            }
        }

        var result = [];

        for (var i = 0; i < rowsCount; i++) {
            var row = [];

            for (var k = 0; k < columnMaxValue; k++) {
                row.push(grid[k][i]);
            }

            result.push(row);
        }

        var data = result.map(row => {
            return row.filter(d => d.rowspan !== 0);
        }).map(row => {
            const size = row.length;
            var columns = [];

            var lastValue = '';
            var lastIndex = 0;
            for (var i = 0; i < size; i++) {
                var currentValue = row[i].value;

                var clone = Object.assign({}, row[i], {
                    colspan: 1
                });

                if (currentValue !== lastValue) {
                    lastValue = currentValue;
                    lastIndex = i;
                } else {
                    columns[lastIndex].colspan = columns[lastIndex].colspan + 1;
                    clone.colspan = 0;
                }

                columns.push(clone);
            }
            return columns.filter(d => d.colspan);
        });

        return {
            scores: response.scores,
            values: response.values,
            data: data.map(row => {
                var size = row.length - 1;
                return {
                    columns: row.filter((d, i) => {
                        return i !== size;
                    }),
                    id: row[size].value
                }
            }),
            domain: response.domain,
            evalExItem: response.evalExItem,
            // evalRequiredItem: response.evalRequiredItem,
        };
    })
    .then(response => {
        var selects = {};

        response.data.forEach((row) => {
            
            var selectScore = response.scores[row.id].selectScore;
            var selectLabel = response.scores[row.id].selectLabel;
            var index = findSelectScore(response.scores[row.id].choices, +selectScore, selectLabel);
            var choice = response.scores[row.id].choices[index];
            selects[row.id] = {
                data: range(+choice.valueLow, +choice.valueHigh),
                value: +selectScore,
                index: index
            };
        });

        var result = response.data.map(d => d.columns.length);

        var size = Math.max.apply(Math, result);

        var columns = range(1, size);
        var reverse = columns.reverse();
        return {
            selects: selects,
            scores: response.scores,
            values: response.values,
            data: response.data,
            columns: reverse,
            loading: false,
            domain: response.domain,
        };
    });
}

const getParents = (id, parents, row) => {
    if (parents.hasOwnProperty(id) === true) {
        return row.unshift(id), getParents(parents[id], parents, row);
    } else {
        return row.slice(1);
    }
}

const range = (start, stop) => {
    var result = [];
    for (stop; stop >= start; stop--) {
        result.push(stop);
    }

    return result;
}

const findSelectScore = (choices, selectScore, selectLabel) => {
    var index = -1;
    for(var i = 0 ; i < choices.length; i++ ){
        const choice = choices[i];
        const min = +choice.valueLow;
        const max = +choice.valueHigh;
        const label = choice.label;
        if(selectScore >= min && selectScore <=max && label === selectLabel) {
            index = i;
            break;
        }
    }
    if (index === -1) {
        for(var i = 0 ; i < choices.length; i++ ){
            if(choices[i].label === selectLabel) {
                index = i;
                break;
            }
        }
    }
    if (index === -1) {
        for(var i = 0 ; i < choices.length; i++ ){
            const choice = choices[i];
            const min = +choice.valueLow;
            const max = +choice.valueHigh;
            if(selectScore >= min && selectScore <=max) {
                index = i;
                break;
            }
        }
    }
    return index;
}

export default {
    querySearch,
    batchSubmit,
    batchBack,
    remove,
    headers,
    onSelect,
    batchRemove,
    setRefresh,
    redirect,
    batchUpdate,
    getSelection,
    onResultStateSelect,
    getResultStateSelect,
    queryDetailById
}